<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Время посещения</h3>
            <p class="bullet03 depth">Время посещения ограничено для безопасности пациентов и предотвращения инфекций. Просим соблюдать указанное время посещений.</p>

            <p class="bullet03 depth">Посещение ограничено 2 часами, с доступом в палату пациента с 18:00 до 20:00 часов в будние дни, и с 10:00 до 12:00 часов и с 18:00 до 20:00 часов в выходные и праздничные дни. Вход в стационарное отделение после 20:00 часов запрещен.</p>

            <p class="bullet03 depth">Время посещений в отделении интенсивной терапии: с 13:00 до 13:30 и с 19:00 до 19:30.</p>

            <p class="bullet03 depth">Опекун, имеющий карту доступа опекуна, выданную при регистрации, имеет доступ в палату в любое время.</p>

            <p class="bullet03 depth">Если пациент находится на карантине ввиду ослабленного иммунитета или инфекционного заболевания, посещение пациента ограничивается в целях предупреждения передачи инфекции и защиты пациента.</p>

            <p class="bullet03 depth">Если вы не желаете, чтобы вас навещали посетители по соображениям конфиденциальности, сообщите об этом администрации и сестринскому посту во время поступления в стационар.</p>

            <p class="bullet03 depth">Просим вести журнал учета посетителей с целью управления потоком посетителей.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Ограничение на посещение</h3>
            <p class="bullet03 depth">Для быстрого восстановления и стабилизации состояния пациентов, а также предотвращения инфекций, запрещается посещать инфекционное палатное отделение и блок интенсивной терапии детям в возрасте 13 лет и младше.</p>
            <p class="bullet03 depth">Посещение пациента опекуном может быть ограничено, если опекун болеет гриппом или иными инфекционными заболеваниями.</p>
            <p class="bullet03 depth">Запрещается проносить внутрь помещений любые потенциальные источники инфекции, например растения, цветочные горшки или животные.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>